import { RouteObject } from "react-router-dom";

const ProtectedRoutes : RouteObject={
    
}

export default ProtectedRoutes;